import type {
  RiskDetailViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';
import React from 'react';

const RiskDetails = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/RiskDetails')),
);

export const RiskDetailsView = (props: RiskDetailViewProps) => {
  return <RiskDetails {...props.data} />;
};
